<template>
  <el-row class="workspace-widget">
    <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
      <div class="left">
        <TaskWidget ref="tasks" :user="user" :visible="true" />
      </div>
    </el-col>
    <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
      <div class="right" v-if="user.chat">
        <ChatWidget ref="rooms" :user="user" :visible="true" />
      </div>
    </el-col>
  </el-row>
</template>
<script>
import TaskWidget from "@/default/pages/tasks/widget.vue";
import ChatWidget from "@/default/pages/chats/widget.vue";
export default {
  name: "WorkspaceWidget",
  components: {
    TaskWidget,
    ChatWidget,
  },
  data() {
    return {
      user: {},
    }
  },
  async mounted() {
    await this.loadOptions();
  },
  methods: {
    async loadOptions() {
      try {
        this.user = (await this.$http.get("/api/v1/users/profile.json")).data;
      } catch (ex) {
        console.error(ex);
      }
    }
  }
}
</script>
<style lang="scss">
.workspace-widget {
  height: calc(100vh - 95px);

  .left {
    height: calc(100vh - 95px);
    overflow: auto;
    border-right: 2px solid #DDD;

    .tasks-widget {
      .main {
        height: calc(100vh - 95px - 35px);
      }
    }
  }

  .right {
    height: calc(100vh - 95px);
    overflow: auto;
    border-left: 2px solid #DDD;

    .chat-widget {
      .main {
        height: calc(100vh - 95px - 35px)
      }
    }
  }
}
</style>